<template>
  <div>
    <transition name="slide">
      <div
        v-if="!hide"
        ref="menu"
        class="menu">
        <div class="first-section">
          <div
            v-if="tokenLength === 0"
            class="no-login">
            <div class="close-menu">
              <i
                class="icon-x"
                @click="close()"/>
            </div>
            <div class="logo-mt">
              <img
                src="@/assets/images/logoW.svg"
                alt="logo-myticket">
            </div>
            <div class="btn-menu">
              <div>
                <el-button
                  class="register"
                  @click="goToCreateAccount">
                  Crear cuenta
                </el-button>
              </div>
              <div>
                <el-button
                  type="text"
                  class="login"
                  @click="goToLogin">
                  Iniciar sesión
                </el-button>
              </div>
            </div>
            <div class="social-media">
              <i class="icon-facebook"/>
              <i class="icon-instagram"/>
              <i class="icon-twitter"/>
              <i class="icon-youtube-play"/>
            </div>
            <!--<div class="user">
              <el-col class="icon-cross">
                <i
                  class="icon-x"
                  @click="close()"/>
              </el-col>
              <el-col class="logo">
                <img
                  src="@/assets/images/logoW.svg"
                  alt="logo-myticket">
              </el-col>
              <el-col class="btn-user">
                <el-button
                  class="bnt-login"
                  @click="goToCreateAccount">Crear cuenta</el-button>
                <br>
                <el-button
                  type="text"
                  class="bnt-login"
                  @click="goToLogin">Iniciar sesión
                </el-button>
              </el-col>
            </div>
            <div class="social-media">
              <i class="icon-facebook"/>
              <i class="icon-instagram"/>
              <i class="icon-twitter"/>
              <i class="icon-youtube-play"/>
            </div>-->
          </div>
          <div v-else>
            <div
              class="header-user-menu">
              <div class="header">
                <img
                  src="@/assets/images/logoW.svg"
                  alt="logo-myticket">
                <i
                  class="icon-x"
                  @click="close()"/>
              </div>
            </div>
            <div class="data-user-menu">
              <div class="profile-img">
                <div class="img"/>
              </div>
              <h1>User</h1>
              <h2>Name User</h2>
              <el-button
                type="text"
                @click="goToProfile()">Mi cuenta</el-button>
            </div>
          </div>
        </div>
        <div class="second-section">
          <div class="myticket">
            <ul>
              <li>Myticket</li>
              <li>Nosotros</li>
              <li>Puntos de venta</li>
              <li @click="goToSearch">Preguntas frecuentes</li>
              <li>Contacto</li>
            </ul>
          </div>
          <div class="sell-with-us">
            <ul>
              <li>Vende con nosotros</li>
              <li>Beneficios</li>
              <li>Tecnología</li>
            </ul>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="!hide"
        class="menu-overlay"
        @click="onClickFade"/>
    </transition>
    <auth-box
      ref="modalaccount">
      <auth-register/>
    </auth-box>
    <auth-box
      ref="modal">
      <auth-sign-in/>
    </auth-box>
  </div>
</template>

<script>
import AuthBox from '../auth/auth-box'
import AuthSignIn from '../auth/auth-sign-in'
import AuthRegister from '../auth/auth-register'
import auth from '@/services/auth.service'
export default {
  name: 'MenuResponsive',
  components: {AuthSignIn, AuthRegister, AuthBox},
  props: {
    closeKeyEsc: {
      type: Boolean,
      default: true
    },
    closeClickFade: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      hide: true,
      token: '',
      tokenLength: 0
    }
  },
  mounted () {
    this.token = auth.token()
    if (this.token != null) {
      this.tokenLength = this.token.length
    }
  },
  methods: {
    open () {
      this.hide = false
      document.body.style.overflow = 'hidden'
    },
    close () {
      this.hide = true
      this.$emit('close')
      document.body.style.overflow = 'auto'
    },
    onPressEsc () {
      if (this.closeKeyEsc) {
        this.close()
      }
    },
    onClickFade () {
      if (this.closeClickFade) {
        this.close()
      }
    },
    goToSearch () {
      this.$router.push({path: '/faq'})
      this.hide = true
    },
    /// //////MODALES///////
    goToCreateAccount () {
      this.$refs.modalaccount.open()
      this.hide = true
    },
    goToLogin () {
      this.$refs.modal.open()
      this.hide = true
    },
    /// //////PROFILE///////
    goToProfile () {
      this.$router.push({path: '/my_account'})
      this.hide = true
    }
  }
}
</script>

<style lang="scss" scoped>

  .first-section {
    height: 40%;
    position: relative;
    .no-login{
      height: 100%;
      background-color: #E64858;
      .close-menu{
        height: auto;
        text-align: right;
        padding: 20px 20px 20px 0;
        i{
          color: white;
          font-size: 14px;
        }
      }
    }
    .logo-mt{
      width: 100%;
      text-align: center;
      margin-bottom: 25px;
      img{
        width: 130px;
        height: 25px;
      }
    }
    .btn-menu{
      width: 100%;
      text-align: center;
      div{
        width: 100%;
      }
      .register{
        background-color: white;
        width: 188px;
        padding: 0;
        height: 40px;
        border: none;
        color: $roseHeader;
        @include font-primary(14px, semibold)
      }
      .login{
        width: 188px;
        padding: 0;
        height: 40px;
        border: none;
        color: white;
        @include font-primary(14px, semibold)
      }
    }
    .social-media{
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }

  .second-section {
    background-color: #F5F5F5;
    height: 60%;
    .myticket {
      border: 1px solid #f5f5f5;
      ul {
        padding: 0;
        margin: 0;
        list-style: none;
        li {
          padding-left: 50px;
          color: $carbon;
          @include font-primary(14px, bold);
          margin-bottom: 20px;
          @media #{$iPhoneSE} {
            padding-left: 30px;
          }
          &:first-child {
            margin-top: 50px;
            @media #{$iPhoneSE} {
              margin-top: 30px;
            }
          }
          &:not(:first-child) {
            color: $dove;
            @include font-primary(14px, regular);
          }
        }
      }
    }
    .sell-with-us {
      ul {
        padding: 0;
        margin: 0;
        list-style: none;
        li {
          padding-left: 50px;
          color: $carbon;
          @include font-primary(14px, bold);
          margin-bottom: 20px;
          @media #{$iPhoneSE} {
            padding-left: 30px;
          }
          &:not(:first-child) {
            color: $dove;
            @include font-primary(14px, regular);
          }
        }
      }
    }
  }

  .menu-overlay {
    background-color: rgba(black, .8);
    position: fixed;
    z-index: 201;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .menu {
    top: 0;
    right: 0;
    z-index: 202;
    position: fixed;
    background-color: white;
    width: 80%;
    height: 100vh;
    transition: all .3s ease-in-out;
    .user {
      background-color: #E64858;
      width: 100%;
      height: 80%;
      .icon-cross {
        margin-top: 5%;
        text-align: right;
        i {
          color: white;
          margin-right: 20px;
          cursor: pointer;
          font-size: 18px;
        }
      }
      .logo {
        margin-top: 7%;
        text-align: center;
        @media #{$Note} {
        }
        @media #{$iPhoneSE} {
        }
        img {
          width: 130px;
          height: 25px;
        }
      }
      .btn-user {
        text-align: center;
        margin-top: 11%;
        button {
          color: white;
          padding: 0;
          @include font-primary(14px, semibold);
          &:not(:last-child) {
            height: 40px;
            width: 188px;
            color: $roseHeader;
            margin-bottom: 20px;
            @include font-primary(14px, semibold);
            box-shadow: 0 5px 10px rgba(#000000, .16);
            border: none;
            @media #{$iPhoneSE} {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    .social-media {
      width: 100%;
      height: 20%;
      background-color: #D34554;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 45px 0 45px;
      i {
        color: rgba(white, .8);
        font-size: 22px;
      }
    }
    .links {
      height: 100%;
    }
  }

  ////////LOGIN//////////////////////
  .header-user-menu{
    background-color: #E64858;
    height: 120px;
    .header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 19px 0 19px;
    }
    img{
      width: 130px;
      height: 25px;
    }
    i{
      color: white;
      font-size: 14px;
    }
  }

  .data-user-menu{
    position: relative;
    text-align: center;
    .profile-img{
      height: 40px;
      display: flex;
      justify-content: center;
      .img{
        top: -40px;
        position: absolute;
        background-image: url("/static/images/image-prpfile.png");
        background-size: cover;
        background-position: center;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 3px solid white;
        box-shadow: 0 7px 30px 0 rgba(0, 0, 0, 0.3);
      }
    }
    h1{
      margin-top: 25px;
      margin-bottom: 0;
      @include font-primary(18px, light);
      color: #444444;
    }
    h2{
      @include font-primary(14px, regular);
      margin: 0;
      color: #777777;
    }
    button{
      color: $roseHeader;
    }
  }
  //////////////////MENU////////////////
  .slide-enter-active {
    transition: all .3s ease-in-out;
  }
  .slide-leave-active {
    transition: all .3s ease-in-out;
  }
  .slide-enter, .slide-leave-to {
    transform: translateX(375px);
  }

  /////////////////////////////////////
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/menu-responsive.vue